import React, { useMemo, useState } from "react";
 import { useTranslation } from "react-i18next";
import {Card,CardBody,Col,Container,FormGroup,Input,Label,Row} from "reactstrap";
import DataTable from "react-data-table-component";
import { ActivityHistoryColumns } from "../../../../data/users/ActivityHistoryList";
import { UserListTableData } from "../../../../data/users/UsersList";
import { Image, P } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../service";
import ReactDatePicker from "react-datepicker";
import { tableHeaderStyles } from "../../../../styles/ReactSelectStyles";
import Breadcrumbs from "../../../../common-elements/breadcrumbs/Breadcrumbs";

interface ActivityHistoryLogsProps {
  userId?: string;
}

function ActivityHistoryLogs({ userId }: ActivityHistoryLogsProps) {
  const { t } = useTranslation();
  const [filterText, setFilterText] = useState("");
  const [selectedUserId, setSelectedUserId] = useState<number | null>(userId ? Number(userId) : null);
  const [startDate, setStartDate] = useState<Date | null>(null);
  console.log(startDate,"startDate")
  
  const handleDateChange = (date: Date | null) => {
    console.log("Selected date:", date); // Check if it's being triggered
    setStartDate(date);
  };


  // Flatten all activity history entries from all users
  const allActivityLogs = UserListTableData.filter(
    (user) => Array.isArray(user.ActivityHistory) && user.ActivityHistory.length > 0
  ).flatMap((user) =>
    user.ActivityHistory!.map((activity) => ({
      id: user.id,
      name: user.name,
      image: user.image,
      organizationname: user.organizationname,
      ...activity,
    }))
  );

  let filteredItems = allActivityLogs;
  if (selectedUserId) {
    filteredItems = filteredItems.filter((item) => item.id === selectedUserId);
  }
  filteredItems = filteredItems.filter((item) => {
    const search = filterText.toLowerCase();
    return (
      (item.name && item.name.toLowerCase().includes(search)) ||
      (item.action && item.action.toLowerCase().includes(search))
    );
  });

  // Get selected user info for header
  const selectedUser = selectedUserId? UserListTableData.find((u) => u.id === selectedUserId): null;

 // Search Section
 const subHeaderComponentMemo = useMemo(() => {
  return (
    <>
      <div id="basic-9_filter" className="dataTables_filter d-flex align-items-center">
        <FormGroup className="d-flex flex-column align-items-stretch">
          <Input
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setFilterText(e.target.value)
            }
            type="search"
            value={filterText}
            placeholder={t("Search")}
          />
        </FormGroup>
      </div>
      <div  id="basic-9_filter"  className="dataTables_filter d-flex align-items-center ms-3">
        <FormGroup className="d-flex flex-column align-items-stretch">
          <ReactDatePicker
            className="datepicker-here form-control"
            selected={startDate}
            onChange={handleDateChange}
            dateFormat="dd/MM/yyyy"
            isClearable 
            placeholderText={t("Date")}
          />
        </FormGroup>
      </div>
    </>
  );
}, [filterText, startDate, t]);

  return (
    <>
      <Breadcrumbs
        mainTitle={t("ActivitylogHistory")}
        parents={[
          { label: t("Users")},
          {
            label: t("organizationAdmin"),
            link: `${process.env.PUBLIC_URL}/users/organization-admin`,
          },
        ]}
      />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                {/* show the selected User and image */}
                <div className="list-product-header d-flex align-items-center mb-3">
                  {selectedUser ? (
                    <>
                    
                      <Image
                        className="media-object rounded-circle img-40 me-2"
                        src={dynamicImage(selectedUser.image)}
                        alt={selectedUser.name}
                      />
                      <P className="mb-0 fw-bold">
                        {selectedUser.name}
                        {selectedUser.organizationname ? (
                          <span className="ms-2 font-primary email_add_0">({selectedUser.organizationname})</span>
                        ) : null}
                      </P>
                    
                    </>
                  ) : (
                    ""
                  )}
                </div>
                {/* Table for Activity History */}
                <div className="list-product">
                  <div className="table-responsive">
                    <DataTable
                      data={filteredItems}
                      columns={ActivityHistoryColumns(t)}
                      striped
                      pagination
                      subHeader
                      customStyles={tableHeaderStyles}
                      subHeaderComponent={subHeaderComponentMemo}
                      pointerOnHover
                      highlightOnHover
                      noDataComponent={
                        <div className="text-center p-4 text-muted">
                          {t("NoActivityhistoryMessage")}
                        </div>
                      }
                    />
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ActivityHistoryLogs;
